import globalData from './fetches/globalData'
import accompaniements from './fetches/accompaniements'
import achievementRanks from './fetches/achievementRanks'
import achievementTasks from './fetches/achievementTasks'
import adminTransactions from './fetches/adminTransactions'
import adminWithdrawals from './fetches/adminWithdrawals'
import adminProducts from './fetches/adminProducts'
import adminProductPurchases from './fetches/adminProductPurchases'
import adminClientDebts from './fetches/adminClientDebts'
import ads from './fetches/ads'

import balance from './fetches/balance'
import balanceStat from './fetches/balanceStat'
import coupons from './fetches/coupons'
import creditWithdrawStats from './fetches/creditWithdrawStats'
import customers from './fetches/customers'
import dashboard from './fetches/dashboard'

import deals from './fetches/deals'
import dishes from './fetches/dishes'
import drinks from './fetches/drinks'
import fees from './fetches/fees'
import functionalitiesStats from './fetches/functionalitiesStats'
import gamificationLevels from './fetches/gamificationLevels'
import kycDocuments from './fetches/kycDocuments'
import kycQueue from './fetches/kycQueue'
import lastOperations from './fetches/lastOperations'
import milestones from './fetches/milestones'
import momoVsCashStat from './fetches/momoVsCashStat'
import notifications from './fetches/notifications'
import operationStats from './fetches/operationStats'
import orders from './fetches/orders'
import packages from './fetches/packages'
import packageCosts from './fetches/packageCosts'
import packageDeliveries from './fetches/packageDeliveries'
import performancesStats from './fetches/performancesStats'
import permissions from './fetches/permissions'
import promotions from './fetches/promotions'
import restaurant from './fetches/restaurant'
import restaurantOrdersStats from './fetches/restaurantOrdersStats'
import restaurants from './fetches/restaurants'
import restaurantBalances from './fetches/restaurantBalances'
import restaurantUsers from './fetches/restaurantUsers'
import riderMessages from './fetches/riderMessages'
import riders from './fetches/riders'
import ridersLive from './fetches/ridersLive'
import riderKyc from './fetches/riderKyc'
import restaurantKyc from './fetches/restaurantKyc'
import roles from './fetches/roles'
import teammates from './fetches/teammates'
import tickets from './fetches/tickets'
import generalAppSettings from './fetches/generalAppSettings'
import balances from './fetches/balances'
import categories from './fetches/categories'
import sponsorships from './fetches/sponsorships'
import rewardLevels from './fetches/rewardLevels'
import rewardRules from './fetches/rewardRules'
import platformStats from './fetches/platformStats'

const data = {
  globalData,
  permissions,
  customers,
  adminTransactions,
  adminWithdrawals,
  restaurants,


  balanceStat,
  creditWithdrawStats,
  functionalitiesStats,
  momoVsCashStat,
  operationStats,
  performancesStats,
  balance,
  restaurant,
  dishes,
  deals,
  lastOperations,
  restaurantOrdersStats,
  promotions,
  coupons,
  achievementTasks,
  achievementRanks,
  orders,
  packages,
  riders,
  ridersLive,
  riderKyc,
  restaurantKyc,
  accompaniements,
  drinks,
  notifications,
  tickets,
  ads,
  fees,
  roles,
  teammates,
  kycDocuments,
  kycQueue,
  dashboard,
  milestones,
  riderMessages,
  gamificationLevels,
  packageDeliveries,
  packageCosts,
  generalAppSettings,
  balances,
  restaurantBalances,
  restaurantUsers,
  categories,
  sponsorships,
  adminProducts,
  adminProductPurchases,
  adminClientDebts,
  rewardLevels,
  rewardRules,
  platformStats,
}

const fetchSerializers = {}
const fetchEndpoints = {}

Object.keys(data).forEach(key => {
  const item = data[key]

  const endpoint = {
    GET: item.url,
  }
  fetchEndpoints[key] = endpoint

  class Serializer {
    get type() {
      return key
    }
    deserialize(...args) {
      return item.parse(...args)
    }
    serialize() {}
  }
  fetchSerializers[key] = Serializer
})

export { fetchSerializers, fetchEndpoints }
